import type { ManagerOptions } from "socket.io-client"

export const FRONT_SOCKETS_CONFIG = {
    defaultSocketIOConfig: {
        autoConnect: false,
        // reconnection: false,
        reconnectionDelay: 20 * 1000, // in ms
        reconnectionAttempts: 5,
        transports: ["websocket"],
    } as ManagerOptions,
}
